// extracted by mini-css-extract-plugin
export default {"commentBox":"CommentList_commentBox__rrW5h","open":"CommentList_open__mNFHh","commentList":"CommentList_commentList__HdOx6"};